import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import SnapshotBrowser from "./components/SnapshotBrowser";
import Features from "./components/Features";
import CompareSection from "./components/CompareSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-sans text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <SnapshotBrowser />
        <Features />
        <CompareSection />
        <FaqSection />
        <AboutSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}